import { Injectable, Inject, Renderer2, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { getQueryParam } from '../helpers/url.helper';
import { InternalStorage } from './sdk/index';

interface ITheme {
    name: string;
    baseColor?: string;
    isActive?: boolean;
}

@Injectable()
export class ThemeService {
    public egretThemes: ITheme[] = [
        {
            name: 'hopetrust',
            baseColor: '#0073C6',
            isActive: false
        },
        {
            name: 'ril-light-green',
            baseColor: '#47803c',
            isActive: false
        },
        {
            name: 'devlanke',
            baseColor: '#3c4d39',
            isActive: false
        },
        {
            name: 'intercityke',
            baseColor: '#3c4d39',
            isActive: false
        },
        {
            name: 'newvalleyke',
            baseColor: '#2face0',
            isActive: true
        },
        {
            name: 'realkenltd',
            baseColor: '#3c4d39',
            isActive: false
        },
        {
            name: 'soithouse',
            baseColor: '#3c4d39',
            isActive: false
        },
        {
            name: 'egret-dark-pink',
            baseColor: '#3c4d39',
            isActive: false
        }
    ];
    public activatedTheme: ITheme;

    settings: any;

    constructor(@Inject(DOCUMENT) private document: Document, private storage: InternalStorage) {
        this.settings = storage.get('host_configs');
    }

    // Invoked in AppComponent and apply 'activatedTheme' on startup
    applyMatTheme(r: Renderer2) {
        /*
         ****** (SET YOUR DEFAULT THEME HERE) *******
         * Assign new Theme to activatedTheme
         */
        // this.activatedTheme = this.egretThemes[0];
        // this.activatedTheme = this.egretThemes[1];
        // this.activatedTheme = this.egretThemes[2];
        const themeStr = JSON.parse(localStorage.getItem('currentTheme')).name;

        this.activatedTheme = {
            name: themeStr,
            baseColor: '#2face0',
            isActive: true
        };

        // *********** get from settings **********
        this.setThemeFromQuery();
        // ************************************

        this.changeTheme(r, this.activatedTheme);
        localStorage.setItem(
            'currentTheme',
            JSON.stringify({
                token: 'current theme',
                name: this.activatedTheme.name
            })
        );
    }

    currentTheme() {
        return JSON.parse(localStorage.getItem('currentTheme'));
    }

    changeTheme(r: Renderer2, theme: ITheme) {
        r.removeClass(this.document.body, this.activatedTheme.name);
        r.addClass(this.document.body, theme.name);
        this.flipActiveFlag(theme);
    }

    flipActiveFlag(theme: ITheme) {
        this.egretThemes.forEach(t => {
            t.isActive = false;
            if (t.name === theme.name) {
                t.isActive = true;
                this.activatedTheme = theme;
            }
        });
    }

    // *********** Get from Settings **********
    setThemeFromQuery() {
        // const themeStr = getQueryParam('theme');
        const themeStr = JSON.parse(localStorage.getItem('currentTheme')).name;
        try {
            this.activatedTheme = JSON.parse(themeStr);
            this.flipActiveFlag(this.activatedTheme);
        } catch (e) {}
    }
}
